
<div class="auto-search" *ngIf="isMobile" [ngClass]="{'inModal': isResults || autoDetail}">
  <div class="auto-search-content" [class.results-mobile]="isResults" [class.detail-mobile]="autoDetail">
    <div class="auto-search-wrapper" #searchContent>
      <app-auto-search-places
        *ngIf="!isAutoDetail"
        [isMobile]="isMobile"
        [isSubmitted]="isSubmitted"
        (inputChanged)="placeInputChanged($event)"
        [isResults]="isResults"
        [autoDetail]="autoDetail"
        (showPickUp)="emitShowPickUp($event)"
        (showDropOff)="emitShowDropOff($event)"
        (placeDropOffSelected)="selectPlace($event, dropOff)"
        (placePickUpSelected)="selectPlace($event, pickUp)"
        (locationNotFoundEvent)="locationNotFoundEvent($event)"
        (popularSelected)="popularSelectedEvent($event)">
      </app-auto-search-places>
      <app-auto-search-datetime
        [isMobile]="isMobile"
        [isSubmitted]="isSubmitted"
        [searchType]="searchType"
        [showCalendarInput]="showCalendarInput"
        [pickUpDate]="pickUpDate"
        [dropOffDate]="dropOffDate"
        [pickUpTime]="pickUpTime"
        [dropOffTime]="dropOffTime"
        (selectTimes)="selectTimes($event)"
        (showMobileCalendarEvent)="showMobileCalendar($event)">
      </app-auto-search-datetime>
    </div>
  </div>
  <app-fixed-surface
    [boxShadow]="true">
    <app-ds-button
      [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
      (clickEvent)="navigateToSearch()">
    </app-ds-button>
  </app-fixed-surface>
</div>
